import { Card, Text } from "@shopify/polaris";

interface MetricCardProps {
  label: string;
  value: string;
  trend: string;
}

export function MetricCard({ label, value, trend }: MetricCardProps) {
  return (
    <Card>
      <div className="metric-card">
        <Text as="p" tone="subdued">
          {label}
        </Text>
        <Text as="p" variant="headingLg">
          {value}
        </Text>
        <Text as="p" tone="success">
          {trend}
        </Text>
      </div>
    </Card>
  );
}
